import { Link } from "react-router-dom";

const FOOTER_CSS = `
.tilprep-public-footer footer { background: #0D1E3D; border-top: 1px solid rgba(255,255,255,.06); }
.tilprep-public-footer .footer-main { max-width: 1400px; margin: 0 auto; padding: 64px 150px 48px 150px; display: grid; grid-template-columns: auto 1fr 1fr auto; gap: 150px; }
.tilprep-public-footer .footer-brand { margin-right: 0; }
.tilprep-public-footer .footer-logo { font-family: var(--font-ui); font-size: 20px; font-weight: 750; color: white; display: flex; align-items: center; gap: 8px; margin-bottom: 14px; }
.tilprep-public-footer .footer-logo img { height: 50px; width: auto; }
.tilprep-public-footer .footer-logo em { font-style: italic; font-family: var(--font-ui); font-size: 22px; color: white; }
.tilprep-public-footer .footer-tagline { font-family: var(--font-ui); font-size: 13px; color: rgba(255,255,255,.6); line-height: 1.65; margin-bottom: 24px; }
.tilprep-public-footer .footer-socials { display: flex; gap: 12px; margin-bottom: 24px; }
.tilprep-public-footer .footer-socials a { display: flex; align-items: center; justify-content: center; width: 36px; height: 36px; border-radius: 50%; border: 1px solid rgba(255,255,255,.15); background: rgba(255,255,255,.06); transition: background .2s, border-color .2s; }
.tilprep-public-footer .footer-socials a:hover { background: rgba(255,255,255,.15); border-color: rgba(255,255,255,.4); }
.tilprep-public-footer .footer-socials a svg { width: 16px; height: 16px; fill: rgba(255,255,255,.55); transition: fill .2s; }
.tilprep-public-footer .footer-socials a:hover svg { fill: white; }
.tilprep-public-footer .footer-col-label { font-family: var(--font-mono); font-size: 9px; letter-spacing: .14em; text-transform: uppercase; color: rgba(255,255,255,.3); margin-bottom: 18px; }
.tilprep-public-footer .footer-links { list-style: none; display: flex; flex-direction: column; gap: 12px; margin: 0; padding: 0; }
.tilprep-public-footer .footer-links a { font-family: var(--font-body); font-size: 14px; color: rgba(255,255,255,.55); text-decoration: none; transition: color .2s; }
.tilprep-public-footer .footer-links a:hover { color: white; }
.tilprep-public-footer .footer-copy { font-family: var(--font-mono); font-size: 10px; color: rgba(255,255,255,.6); letter-spacing: .06em; }
@media (max-width: 900px) {
  .tilprep-public-footer .footer-main { grid-template-columns: 1fr 1fr; gap: 40px; padding: 48px 20px 32px; }
  .tilprep-public-footer .footer-bottom { padding: 20px; flex-direction: column; gap: 12px; }
}
@media (max-width: 600px) {
  .tilprep-public-footer .footer-main { grid-template-columns: 1fr; gap: 32px; padding: 40px 20px 24px; }
  .tilprep-public-footer .footer-logo img { height: 40px; }
  .tilprep-public-footer .footer-logo em { font-size: 20px; }
}
@media (max-width: 768px) {
  .tilprep-public-footer .footer-bottom {
    flex-direction: column !important;
    align-items: center !important;
    text-align: center;
    gap: 8px !important;
    padding: 20px !important;
  }
  .tilprep-public-footer .footer-bottom .footer-bottom-left {
    display: contents !important;
  }
  .tilprep-public-footer .footer-bottom .footer-legal-links {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    justify-content: center;
  }
  .tilprep-public-footer .footer-bottom .footer-tagline-bottom {
    text-align: center;
  }
}
`;

const PublicFooter = () => {
  return (
    <div className="tilprep-public-footer">
      <style dangerouslySetInnerHTML={{ __html: FOOTER_CSS }} />
      <footer>
        <div className="footer-main">
          <div className="footer-brand">
            <div className="footer-logo"><img src="/white_logo.svg" alt="TILPrep logo — TIL-I exam prep platform for Politecnico di Torino" />TILPrep</div>
            <p className="footer-tagline">
              Built by those who know PoliTO.<br />
              The real exam. The real scores.<br />
              The real rankings. Your admission<br />
              journey starts here.
            </p>
            <div className="footer-socials">
              <a href="https://www.instagram.com/tilprep.polito/" target="_blank" rel="noreferrer" aria-label="Instagram">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5A4.25 4.25 0 0 0 16.25 3.5Zm4.25 3.25a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Zm0 1.5a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Zm5.5-1.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"/></svg>
              </a>
              <a href="https://t.me/+6UM5IbEk2EY3ZWU1" target="_blank" rel="noreferrer" aria-label="Telegram">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.93 6.81-1.65 7.78c-.12.56-.45.7-.91.43l-2.52-1.86-1.22 1.17c-.13.14-.25.25-.51.25l.18-2.58 4.7-4.25c.2-.18-.05-.28-.32-.1l-5.81 3.66-2.5-.78c-.55-.17-.56-.55.11-.81l9.77-3.77c.45-.17.85.11.68.81Z"/></svg>
              </a>
              <a href="mailto:info@tilprep.com" aria-label="Email">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 4.24-8 4.57-8-4.57V6l8 4.57L20 6v2.24Z"/></svg>
              </a>
            </div>
          </div>
          <div>
            <div className="footer-col-label">Platform</div>
            <ul className="footer-links">
              <li><Link to="/resources">Resources</Link></li>
              <li><Link to="/support">Support</Link></li>
              <li><a href="#">Admission Guide</a></li>
              <li><a href="#">Scholarships</a></li>
            </ul>
          </div>
          <div>
            <div className="footer-col-label">Community</div>
            <ul className="footer-links">
              <li><a href="https://t.me/+6UM5IbEk2EY3ZWU1" target="_blank" rel="noreferrer">TILPrep.PoliTO</a></li>
              <li><a href="https://www.instagram.com/tilprep.polito/" target="_blank" rel="noreferrer">@tilprep.polito</a></li>
              <li><a href="https://www.instagram.com/lifeatpolito/" target="_blank" rel="noreferrer">@lifeatpolito</a></li>
              <li><a href="https://t.me/+FvVY3DTqITgyNzRl" target="_blank" rel="noreferrer">PoliTO Fresher Community</a></li>
            </ul>
          </div>
          <div>
            <div className="footer-col-label">Contact</div>
            <ul className="footer-links">
              <li><a href="mailto:info@tilprep.com">info@tilprep.com</a></li>
            </ul>
          </div>
        </div>
        <div
          className="footer-bottom"
          style={{
            borderTop: "1px solid rgba(255,255,255,.06)",
            padding: "20px 60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            maxWidth: 1200,
            margin: "0 auto",
          }}
        >
          <div className="footer-bottom-left" style={{ display: "flex", alignItems: "center", gap: 24 }}>
            <div className="footer-copy">© 2026 TILPrep</div>
            <div className="footer-legal-links" style={{ display: "flex", alignItems: "center", gap: 24 }}>
              <Link
              to="/privacy"
              style={{ fontFamily: "var(--font-mono)", fontSize: 10, letterSpacing: ".06em", color: "rgba(255,255,255,.55)", textDecoration: "none" }}
              >Privacy Policy</Link>
              <Link
              to="/terms"
              style={{ fontFamily: "var(--font-mono)", fontSize: 10, letterSpacing: ".06em", color: "rgba(255,255,255,.55)", textDecoration: "none" }}
              >Terms of Service</Link>
              <Link
              to="/trust"
              style={{ fontFamily: "var(--font-mono)", fontSize: 10, letterSpacing: ".06em", color: "rgba(255,255,255,.55)", textDecoration: "none" }}
              >Trust &amp; Security</Link>
            </div>
          </div>
          <span
            className="footer-tagline-bottom"
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: 10,
              letterSpacing: ".12em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,.4)",
            }}
          >
            A PROJECT BY LIFE AT POLITO · TURIN, ITALY
          </span>
        </div>
      </footer>
    </div>
  );
};

export default PublicFooter;